import * as React from 'react'
import { Link } from 'react-router-dom'

import { Community, Event, Place, Story } from '../../../models'
import { CurrentUserContext } from '../../../providers/CurrentUserContext'
import Routes from '../../../startup/routes'
import { IconGlyph, IconGlyphColor } from '../../../icons/IconGlyph'

// The icon font colored its edit-event/-place/-story glyphs red/green/blue.
const EDIT_ICON_COLORS: Partial<Record<NonNullable<Props['resourceName']>, IconGlyphColor>> = {
  event: 'red',
  place: 'green',
  story: 'blue',
}

interface Props {
  record?: Event | Community | Place | Story
  resourceName?: 'event' | 'community' | 'place' | 'story'
}

export const ActionControls: React.FC<Props> = ({ record, resourceName = record && record.objectType }) => {
  const { currentUser } = React.useContext(CurrentUserContext)
  if (!record || !currentUser) return null

  if (record.submitter?.id === currentUser.id || currentUser.isCurator) {
    return (
      <p className={`${resourceName}-edit`}>
        <Link to={Routes.editPath(resourceName, record)}>
          <IconGlyph name="pencil-edit" color={resourceName && EDIT_ICON_COLORS[resourceName]} />
          Edit
        </Link>
      </p>
    )
  }

  return null
}
